
@if (larguraTela && larguraTela < 1250) {
  <app-sessao-mobile
    [sessoes]="sessoes"
    [carregando]="carregandoDadosTabela"
    [larguraTela]="larguraTela"
    (modalFritoEmit)="abrirModalFiltro()"
    (filtrosEmit)="iniciarFiltros(true)"
    (nomeBuscadoEmit)="filtrarPorNome($event)"
    (exibirDetalhes)="abrirModalDetalhes($event, true)"
    (modalChat)="abrirModalChat($event)"
    (edicaoDetalhes)="abrirModalDetalhes($event, false)"
    (reiniciarSessao)="reiniciarSessao($event)"
  >
  </app-sessao-mobile>
}
@else {
  <div class="flex-direction-column page">
    <div class="flex-direction-row justify-between align-center" style="margin-bottom: 1.0vh">
      <div class="flex-direction-row align-center gap-10" [formGroup]="formSessao">
        <app-button-padrao
          iconSrc="icones/filtros"
          iconSrcExtensao=".svg"
          width="30px"
          height="30px"
          backgroundColor="transparent"
          widthIcon="22px"
          heightIcon="22px"
          matTooltip="Filtrar"
          (buttonClick)="abrirModalFiltro()">
        </app-button-padrao>

        <app-button-padrao
          iconSrc="icones/limpar"
          iconSrcExtensao=".svg"
          width="30px"
          height="30px"
          backgroundColor="transparent"
          widthIcon="22px"
          heightIcon="22px"
          matTooltip="Limpar filtros"
          (buttonClick)="iniciarFiltros(true)">
        </app-button-padrao>

        <app-form-field
          style="margin-right: 1%"
          placeholder="Pesquisar"
          iconPrefix="search"
          iconColor="var(--primary)"
          backgroundColor="transparent"
          classe="pesquisar"
          widthFormField="325px"
          heightFormField="35px"
          borderColor="var(--primary)"
          formControlName="numNome">
        </app-form-field>
      </div>
    </div>

    @if (sessoes.length > 0 && !carregandoDadosTabela) {
      <mat-table [dataSource]="sessoesDataSource" [trackBy]="trackById" class="mat-mdc-table">
        <ng-container matColumnDef="acao">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let elemento">
            <div class="flex-direction-row gap-5">
              <app-button-padrao
                iconSrc="icones/visualizar"
                iconSrcExtensao=".svg"
                width="30px"
                height="30px"
                backgroundColor="transparent"
                widthIcon="22px"
                heightIcon="22px"
                (buttonClick)="abrirModalDetalhes(elemento, true)">
              </app-button-padrao>

              <app-button-padrao
                iconSrc="icones/comentario-alt"
                iconSrcExtensao=".svg"
                width="30px"
                height="30px"
                backgroundColor="transparent"
                widthIcon="22px"
                heightIcon="22px"
                (buttonClick)="abrirModalChat(elemento)">
              </app-button-padrao>

              <app-button-padrao
                iconSrc="icones/dialogo"
                iconSrcExtensao=".svg"
                width="30px"
                height="30px"
                backgroundColor="transparent"
                widthIcon="22px"
                heightIcon="22px"
                (buttonClick)="abrirModalDetalhes(elemento, false)">
              </app-button-padrao>

              @if (elemento.ativo) {
                <app-button-padrao
                  iconSrc="icones/reinicio-icon"
                  iconSrcExtensao=".svg"
                  width="30px"
                  height="30px"
                  backgroundColor="transparent"
                  widthIcon="22px"
                  heightIcon="22px"
                  [matTooltip]="'Reiniciar sessão'"
                  (buttonClick)="reiniciarSessao(elemento)">
                </app-button-padrao>
              }
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef>ID</mat-header-cell>
          <mat-cell *matCellDef="let elemento">{{ elemento.id }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="tempoParaFinalizar">
          <mat-header-cell *matHeaderCellDef>Tempo para finalização</mat-header-cell>
          <mat-cell *matCellDef="let elemento">
            @if (elemento.ativo && elemento.dataFormatadaFinalizar !== '00:00') {
              <app-progress-bar-data
                [data]="elemento.dataFormatadaFinalizar"
                [tempoFinalizar]="elemento.tempoFinalizar"
                [verificaFinalizada]="true">
              </app-progress-bar-data>
            } @else if (elemento.ativo && elemento.dataFormatadaFinalizar === '00:00') {
              <span>Finalizado</span>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="etapaFluxoAtual">
          <mat-header-cell *matHeaderCellDef>Fluxo/Etapa Atual</mat-header-cell>
          <mat-cell *matCellDef="let elemento">
            {{ elemento.fluxo?.nome || '-' }} | {{ elemento.etapa?.titulo || '—' }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="tempoEtapaAtual">
          <mat-header-cell *matHeaderCellDef matTooltip="Tempo na etapa atual">TEA</mat-header-cell>
          <mat-cell *matCellDef="let elemento" class="ellipse">
            {{ elemento.tempoEtapaAtual ? elemento.tempoEtapaAtual + 'h' : '' }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="numeroContato">
          <mat-header-cell *matHeaderCellDef>N. Contato</mat-header-cell>
          <mat-cell *matCellDef="let elemento">
            @if (restricoes.includes('OCULTAR_NUMERO_CELULAR')) {
              <div class="tarja"></div>
            } @else {
              {{ elemento.contato.numero | celularMask }}
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="nomeContato">
          <mat-header-cell *matHeaderCellDef>Nome Contato</mat-header-cell>
          <mat-cell *matCellDef="let elemento" class="ellipse" matTooltip="{{ elemento.contato.nome }}">
            {{ elemento.contato.nome }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="dataInicio">
          <mat-header-cell *matHeaderCellDef>Data Abertura</mat-header-cell>
          <mat-cell *matCellDef="let elemento" class="ellipse" matTooltip="{{ elemento.dataInicio | date:'dd/MM/yyyy - HH:mm' }}">
            {{ elemento.dataInicio | date:'dd/MM/yyyy - HH:mm' }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="dataUltimaMensagem">
          <mat-header-cell *matHeaderCellDef>Última interação</mat-header-cell>
          <mat-cell *matCellDef="let elemento" class="ellipse" matTooltip="{{ elemento.dataUltimaMensagem | date:'dd/MM/yyyy - HH:mm' }}">
            {{ elemento.dataUltimaMensagem | date:'dd/MM/yyyy - HH:mm' }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="operador">
          <mat-header-cell *matHeaderCellDef>Operador</mat-header-cell>
          <mat-cell *matCellDef="let elemento" matTooltip="{{ elemento.operador?.nome }}">
            <span class="ellipse">{{ elemento.operador?.nome }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="canal">
          <mat-header-cell *matHeaderCellDef>Canal</mat-header-cell>
          <mat-cell *matCellDef="let elemento" matTooltip="{{ elemento.canal?.nome }}">
            {{ elemento.canal?.nome }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="ativo">
          <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
          <mat-cell *matCellDef="let elemento" class="ellipse">
            {{ elemento.ativo ? 'Ativo' : elemento.tempoFinalizar > 0 ? 'Finalizado Manualmente' : 'Finalizado' }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="remetente">
          <mat-header-cell *matHeaderCellDef>N. Remetente</mat-header-cell>
          <mat-cell *matCellDef="let elemento" [matTooltip]="elemento.conta.nome + '|' + (elemento.conta.numero | celularMask)">
            <span class="ellipse">{{ elemento.conta.nome }} | {{ elemento.conta.numero | celularMask }}</span>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>

      <app-paginator
        [length]="length"
        [pageSize]="limit"
        [pageIndex]="page"
        [width]="'calc(100% - 16px) !important'"
        (pageChange)="handlePageEvent($event)">
      </app-paginator>
    } @else if (sessoes.length <= 0 && !carregandoDadosTabela) {
      <div class="flex center-center height-100">
        <img style="height: 394px; width: 582px;" src="./assets/imagem-mulher-nao-eh-bug.png" alt="">
      </div>
    } @else if (carregandoDadosTabela) {
      <app-tabela-skeleton [qntdLinhas]="5"></app-tabela-skeleton>
    }
  </div>
}
